import { useState } from "react";
import { styled } from '@mui/material/styles';
import {
  AppBar,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  ThemeProvider,
  createTheme,
  useMediaQuery,
  Divider,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from '@mui/icons-material/Logout';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import LOGO_KYUDEN from '../_img/logo_kyuden.svg';
import { BoxSpaceBetween } from '../style/box';
import { ENVIRONMENT_LABEL } from '../const/config';

const theme = createTheme({
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      },
    },
  },
});

// AppBarのスタイリング（ドロワー対応）
const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: '100%',
}));

export default function Header({ open, setOpen }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMobile = useMediaQuery("(max-width:600px)");
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
    handleClose();
  };

  const handleMyPage = async () => {
    navigate('/my_page');
    handleClose();
  };

  return (
    <BoxSpaceBetween>
      <ThemeProvider theme={theme}>
        <StyledAppBar position="fixed" open={open}>
          <Toolbar>
            {/* メニューボタン */}
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={[
                { marginRight: 2 },
                open && { display: 'none' },
              ]}
            >
              <MenuIcon />
            </IconButton>

            {/* ロゴ */}
            <img
              src={LOGO_KYUDEN}
              alt="Logo"
              style={{ height: isMobile ? 25 : 40, marginRight: 10 }}
            />

            {/* タイトル */}
            <Typography
              variant="h6"
              sx={{ flexGrow: 1, fontWeight: "bold", fontSize: { xs: "0.4rem", sm: "1.2rem" } }}
            >
              大分管内水力発電所　自然災害リスク対応支援システム
            </Typography>
            <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
              <Typography
                sx={{
                  fontSize: { xs: '0.6rem', sm: '1.5rem' },
                  color: 'red',
                  fontWeight: 'bold',
                  ml: { xs: 1, sm: 2 },
                }}
              >
                {ENVIRONMENT_LABEL}
              </Typography>
            </Box>

            {/* ユーザーアバター */}
            {currentUser && (
              <IconButton
                sx={{ mr: { xs: 1, sm: 2 } }}
                onClick={handleOpen}
              >
                <Avatar
                  sx={{ width: { xs: 30, sm: 40 }, height: { xs: 30, sm: 40 }, fontSize: { xs: '1rem', sm: '1.5rem' } }}
                >
                  {currentUser.name.charAt(0)}
                </Avatar>
              </IconButton>
            )}

            {/* メニュー */}
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {/* ユーザー情報 */}
              <MenuItem
                onClick={(e) => e.stopPropagation()}
                sx={{
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  pointerEvents: 'none'
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                  {currentUser?.name}
                </Typography>
              </MenuItem>
              <Divider />
              <MenuItem onClick={handleMyPage}>
                <AccountBoxIcon fontSize="small" sx={{ mr: 1 }} />
                マイページ
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                ログアウト
              </MenuItem>
            </Menu>
          </Toolbar>
        </StyledAppBar>
      </ThemeProvider>
    </BoxSpaceBetween>
  );
}